import { useContext } from "react";
import { formatCurrencyToLocale } from "../../../../utils/method";
import { ELEMENT_TYPES } from "../constants/boqElementTypes";
import { BoQDraftContext } from "./BoQGridContext";

export function TotalPriceCell({ row }) {
    const { values: draftValues, editingRowId } = useContext(BoQDraftContext);
    const isEditing = editingRowId === row.original.id;
    const qty = isEditing
        ? (draftValues.quantity !== undefined ? draftValues.quantity : row.original.quantity)
        : row.original.quantity;
    const price = isEditing
        ? (draftValues.unitPrice !== undefined ? draftValues.unitPrice : row.original.unitPrice)
        : row.original.unitPrice;
    const stored = isEditing ? null : row.original.totalPrice;
    const total = stored ?? (Number(qty) || 0) * (Number(price) || 0);
    if (row.original?.type !== ELEMENT_TYPES.POSITION && total === 0) return null;
    return formatCurrencyToLocale(total);
}

export function TotalPriceGrossCell({ row }) {
    const { values: draftValues, editingRowId } = useContext(BoQDraftContext);
    const isEditing = editingRowId === row.original.id;
    const qty = isEditing
        ? (draftValues.quantity !== undefined ? draftValues.quantity : row.original.quantity)
        : row.original.quantity;
    const price = isEditing
        ? (draftValues.unitPrice !== undefined ? draftValues.unitPrice : row.original.unitPrice)
        : row.original.unitPrice;
    const taxRate = isEditing
        ? (draftValues.taxRate !== undefined ? draftValues.taxRate : row.original.taxRate)
        : row.original.taxRate;
    const stored = isEditing ? null : row.original.totalPriceGross;
    const net = (Number(qty) || 0) * (Number(price) || 0);
    const gross = stored ?? net * (1 + (Number(taxRate) || 0));
    if (row.original?.type !== ELEMENT_TYPES.POSITION && gross === 0) return null;
    return formatCurrencyToLocale(gross);
}
